import { getFullUrl } from "../../../../utils/helper";
import { RewardItemProps } from "../../types";

const RewardItem = ({ url, title }: RewardItemProps) => {
  return (
    <div className="card flex flex-col justify-center items-center gap-[12px] w-[442px] p-[12px] min-h-[120px] max-md:min-h-[98px] max-md:w-[48%]" >
      <img
        src={getFullUrl(url)}
        alt={title}
        width={60}
        height={60}
        loading="lazy"
        decoding="async"
        className="h-[60px] w-[60px] object-contain max-md:h-[42px] max-md:w-[42px]"
      />
      <div className={`text-[16px] font-normal text-black line-clamp-2 leading-[24px] max-md:text-[14px] max-md:leading-[20px] break-all `}>{title}</div>
    </div>
  );
};

export default RewardItem;